/**
 * Hunt Status Enum
 * Represents the lifecycle state of a hunt
 */
export var HuntStatus;
(function (HuntStatus) {
    HuntStatus["LOBBY"] = "lobby";
    HuntStatus["SETUP"] = "setup";
    HuntStatus["READY"] = "ready";
    HuntStatus["STARTING"] = "starting";
    HuntStatus["ACTIVE"] = "active";
    HuntStatus["COMPLETED"] = "completed";
    HuntStatus["EXPIRED"] = "expired";
})(HuntStatus || (HuntStatus = {}));
//# sourceMappingURL=hunt.js.map